const paramsFormat = function(params) {
    const data = new FormData();
    for (const key in params) {
        if (Object.hasOwnProperty.call(params, key)) {
            data.append(key, params[key]);
        }
    }
    return data;
}

const req = function(url, data, method = 'POST') {
    return new Promise((resolve, reject) => {
        fetch(url, {
            method: method,
            body: paramsFormat(data)
        }).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                const reason = `${response.status}:${response.statusText}`;
                reject(reason);
            }
        }).then((res) => {
            resolve(res);
        }).catch((error) => {
            reject(error);
        });
    })
}

const reqByToken = function(url, data, method = 'POST') {
    let api_host = 'https://h5api.tarsocial.com';
    if (["localhost", "0.0.0.0", "h5wxfront.tarh5.com"].includes(window.location.hostname)) {
        api_host = 'http://t.h5wxapi.tarsocial.com';
    }
    let params = paramsFormat(data);
    params.append('token', localStorage.getItem(`${tarTid}_token`));
    return new Promise((resolve, reject) => {
        fetch(api_host + url, {
            method: method,
            body: params
        }).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                const reason = `${response.status}:${response.statusText}`;
                reject(reason);
            }
        }).then((res) => {
            resolve(res);
        }).catch((error) => {
            reject(error);
        });
    })
}

const reqByTokenInJson = function(url, data, method = 'POST') { //data为json对象
    let api_host = 'https://h5api.tarsocial.com';
    if (["localhost", "0.0.0.0", "h5wxfront.tarh5.com"].includes(window.location.hostname)) {
        api_host = 'http://t.h5wxapi.tarsocial.com';
    }
    data['token'] = localStorage.getItem(`${tarTid}_token`);
    return new Promise((resolve, reject) => {
        fetch(api_host + url, {
            method: method,
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                const reason = `${response.status}:${response.statusText}`;
                reject(reason);
            }
        }).then((res) => {
            resolve(res);
        }).catch((error) => {
            reject(error);
        });
    })
}


const getAuthCfg = (params) => {
    return req('https://api.h5mo.com/v1/taropen/get_auth_cfg', params);
}


const FansInfoByAuth = (params) => {
    return req('https://api.h5mo.com/v1/wxopen/auth_fansinfo', params);
}


const FansInfoByToken = (params) => {
    let api_host = 'https://h5api.tarsocial.com';
    if (["localhost", "0.0.0.0", "h5wxfront.tarh5.com"].includes(window.location.hostname)) {
        api_host = 'http://t.h5wxapi.tarsocial.com';
    }
    return req(api_host + '/token/get_token_info', params);
}


const getWxShareCfg = (params) => {
    return req('https://api.h5mo.com/v1/wxopen/wxshare', params);
}


const getTitle = (params) => {
    let api_host = 'https://h5api.tarsocial.com';
    if (["localhost", "0.0.0.0", "h5wxfront.tarh5.com"].includes(window.location.hostname)) {
        api_host = 'http://t.h5wxapi.tarsocial.com';
    }
    req(api_host + '/weplay/weplaytitle/get_title', params).then((res) => {
        if (res.errcode == 0) {
            res.data && (document.title = res.data);
        }
    });
}


const encrypt = (params) => {
    return req('https://api.h5mo.com/v1/wxopen/encrypt', params);
}

export const api = { getAuthCfg, FansInfoByAuth, FansInfoByToken, getWxShareCfg, getTitle, encrypt };


//在此注册接口

//获取评论列表
const getComList = (params) => {
    return reqByToken('/storage/comments/message_list', params);
}

//提交评论
const submitComment = (params) => {
    return reqByTokenInJson('/storage/comments/message', params);
}


// 看视频抽奖
const watchedDraw = (params) => {
    return reqByToken('/libai/activity/watched_draw_v3', params);
}

// 查询个人排名情况
const query = (params) => {
    return reqByToken('/libai/activity/query_v3', params);
}

// 领取实物奖励-提交领取地址
const submit = (params) => {
    return reqByToken('/libai/activity/obtain_v3', params);
}

// 订阅模板消息通知
const subscribe = (params) => {
    return reqByToken('/internaldemand/domain/subscribe', params);
}

export const h5api = { getComList, submitComment, watchedDraw, query, submit, subscribe }; //在此导出
